// extracted by mini-css-extract-plugin
export default {"container":"style_container__c4bqT","pageContainer":"style_pageContainer__23NAq","page":"style_page__gAcn2","btn":"style_btn__IOMN+","btnfwd":"style_btnfwd__3veQr"};